$card-color: "#FFF";
$card-content-background-color: "#000";

.tileBorder {
	border-top: 1vw solid #ff8a0c;
}
@media screen and (min-width: 768px) {
	.tileBorder {
		border-top: 3px solid #ff8a0c;
	}
}
@media screen and (min-width: 1024px) {
	.tileBorder {
		border-top: 2px solid #ff8a0c;
	}
}
